/**
 * Email Customization Feature Routes — Product Portal
 */
import type { RouteRecordRaw } from 'vue-router';

export const emailCustomizationRoutes: RouteRecordRaw[] = [
  {
    path: '/email-customization',
    name: 'email-customization',
    component: () => import('./views/EmailCustomizationView.vue'),
    meta: {
      title: 'Email Customization',
      breadcrumbs: [
        { label: 'Settings', to: { name: 'settings-dashboard' } },
        { label: 'Email Customization' },
      ],
    },
  },
];
